// Vuex
// import store from '@/store.js';

import Request from './request';

async function materials(data) {
    return Request('get', "api/top/get-materials", data);
}

async function stockMaterials(data) {
    return Request('get', "api/top/get-stock-materials", data);
}

async function getOrderCount() {
    return Request('get', "api/top/get-order-count");
}

async function getShopInfo() {
    return Request('get', "api/top/get-shop-info");
}

async function stockTakePlan() {
    return Request('get', "api/top/notice_stock_take_plan");
}

export default {
    materials,
    stockMaterials,
    getOrderCount,
    getShopInfo,
    stockTakePlan,
};